<template>
  <div class="lidar-container" id="lidar_groups">
    <b-row class="w-100 blue-background tg-header" :class="!lidarMinimized ? 'tg-header-border' : ''" no-gutters>
      <b-col class="col-sm-9 d-flex justify-content-start align-items-center flex-row pl-4">
        <span class="capitalize">Lidar Groups</span>
      </b-col>
      <b-col class="col-sm-2 d-flex justify-content-center align-items-center">
        <fa
          id="minOrMaxLidarPanelElement"
          class="float-right clickable"
          :title="lidarMinimized ? 'Maximize Lidar Panel' : 'Minimize Lidar Panel'"
          :icon="['fas', lidarMinimized ? 'window-maximize' : 'window-minimize']"
          @click="toggleLidarHeight()"
        />
      </b-col>
    </b-row>
    <b-row v-if="!lidarMinimized" no-gutters class="w-100 scrollable p-2 tg-body">
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column g-3" v-if="!lidarIsLoading && distinct_lidar.length > 0">
        <b-row
          v-for="IDobj in distinct_lidar"
          :key="IDobj.dateCode"
          :id="'lidar_' + IDobj.dateCode"
          class="w-100"
          no-gutters
        >
          <b-col class="col-sm-10 d-flex justify-content-center align-items-center">
            <b-button
              style="padding: 0px"
              class="btn py-1 lidar-label-size text-color"
              size="sm"
              @click="toggleLidarGroup(IDobj, true, $event)"
              :class="anyPointcloudOfLidarGroupVisible(IDobj.dateCode)"
              variant="transparent"
            >
              {{ IDobj.dateCode }}
            </b-button>
          </b-col>
          <b-col class="col-sm-2 d-flex justify-content-start align-items-center text-color">
            <fa
              class="clickable"
              @click="expandLidarGroup(IDobj)"
              size="lg"
              :icon="['fas', IDobj.groupIsCollapsed ? 'caret-down' : 'caret-up']"
            />
          </b-col>
          <b-row v-if="!IDobj.groupIsCollapsed" id="pointCloudContainer" class="w-100 mt-1" no-gutters>
            <b-row
              v-for="pointcloudID in IDobj.pointcloudIDArr"
              :key="pointcloudID"
              class="w-100 d-flex justify-content-center align-items-center mt-1 pl-1 text-color"
              no-gutters
            >
              <b-col class="col-sm-12 d-flex justify-content-center align-items-center">
                <b-button
                  size="sm"
                  class="btn w-100 text-truncate"
                  style="font-size: 0.6rem;"
                  variant="transparent"
                  :id="`pc-${pointcloudID}`"
                  :class="availableLidarButtonCtrl(pointcloudID)"
                  @click="toggleLidarLayer(pointcloudID, IDobj.dateCode)"
                  v-b-tooltip.hover
                  :title="pointcloudID"
                >
                  {{ pointcloudID }}
                </b-button>
              </b-col>
            </b-row>
          </b-row>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else-if="lidarIsLoading">
        <b-row no-gutters>
          <span class="d-flex justify-content-center my-4">
            <fa :icon="['fas', 'spinner']" size="3x" class="fa-spin tg-spinner"/>
          </span>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else-if="!lidarMinZoomAchieved">
        <b-row no-gutters class="d-flex justify-content-center align-items-center w-100 tg-warning" style="gap: 15px">
          <span class="d-flex justify-content-center">
            <fa :icon="['fas', 'exclamation-triangle']" size="2x"/>
          </span>
          <span class="d-flex justify-content-center">
            Zoom Level 17+
          </span>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else>
        <b-row no-gutters>
          <span class="d-flex justify-content-center mt-4">
            No available Lidar at current location
          </span>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.disable {
  opacity: 0.6;
  pointer-events: none;
}

.lidar-container {
  width: 12.5rem;
  display: flex;
  flex-direction: column;
  max-height: calc(var(--vh, 1vh) * 100 - 10rem);
  /* border: 1px solid rgba(6, 60, 109, 0.12); */
  background: transparent;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(6, 60, 109, 0.12);
  color: #063c6d;
  overflow: hidden;
  font-family: system-ui, -apple-system, sans-serif;
}

.tg-header {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.75rem;
  background: #063c6d;
}

.tg-header-border {
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.tg-header span {
  color: #ffffff !important;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.tg-header .clickable {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.75rem;
}
.tg-header .clickable:hover {
  color: #ffffff !important;
}

.tg-body {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding: 0.5rem;
  background-color: #eef3f9;
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
}

.tg-body::-webkit-scrollbar {
  width: 4px;
}
.tg-body::-webkit-scrollbar-track {
  background: transparent;
}
.tg-body::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.22);
  border-radius: 2px;
}
.tg-body::-webkit-scrollbar-button {
  display: none;
}

.lidar-label-size {
  width: 80%;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 6px;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.lidar-container .w-100.mt-1 {
  margin-top: 0.25rem !important;
}

.lidar-container .clickable {
  color: rgba(6, 60, 109, 0.8);
  transition: color 0.15s ease;
}
.lidar-container .clickable:hover {
  color: #063c6d;
}

.lidar-container span {
  color: #063c6d;
  font-size: 0.6rem;
}

.lidar-group-off {
  color: #063c6d;
  background: #fff;
  border: 1px solid rgba(6, 60, 109, 0.2);
}

.lidar-group-off:hover {
  color: #063c6d;
  background: rgba(6, 60, 109, 0.06);
  border-color: rgba(6, 60, 109, 0.4);
}

.lidar-off {
  color: #063c6d;
  background: #fff;
  border: 1px solid rgba(6, 60, 109, 0.18);
}

.lidar-off:hover {
  color: #063c6d;
  background: rgba(6, 60, 109, 0.06);
  border-color: rgba(6, 60, 109, 0.35);
}

.lidar-container .btn-primary {
  color: #ffffff;
  background: #063c6d;
  border-color: #063c6d;
}

.lidar-container .btn-primary:hover {
  background: #0a4f8f;
  border-color: #0a4f8f;
}

.blue-border-bottom {
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.blue-background {
  background: #063c6d;
  color: #ffffff !important;
  border-radius: 6px 6px 0 0;
}

.tg-spinner {
  color: rgba(6, 60, 109, 0.5) !important;
}

.tg-warning {
  color: #b26a00;
}
.tg-warning span {
  color: #b26a00 !important;
  font-weight: 600;
}

.text-color {
  color: #063c6d;
}
</style>

<script>
import {Tile as TileLayer} from 'ol/layer'
import {XYZ} from 'ol/source'
export default {
  name: "Generic_LidarTiles",
  props: [
    'showLidarPanel',
    'lidarMinZoomAchieved',
    'distinct_lidar',
    'lidarIsLoading',
    'map',
    'selectedExtent',
    'zoomLevel'
  ],
  data() {
    return {
      apiUrl: null,
      lidarGroup: null,
      currentIndex: 0,
      lidarMinimized: false
    }
  },
  methods: {
    toggleLidarHeight() {
      this.lidarMinimized = !this.lidarMinimized
    },
    expandLidarGroup(IDobj) {
      IDobj.groupIsCollapsed = !IDobj.groupIsCollapsed
    },
    toggleLidarLayer(pointcloudID, group, turnWholeGroupOn = false) {
      let needToCreateLidarLayer = true

      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == `${pointcloudID}lidar`) {
          needToCreateLidarLayer = false
          if (turnWholeGroupOn) {
            layer.setVisible(true)
          } else if (layer.getVisible()) {
            layer.setVisible(false)
          } else {
            layer.setVisible(true)
          }
        }
      })

      if (needToCreateLidarLayer) {
        let url
        switch (this.selectedExtent) {
          default:
            url = `https://drt-2d.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
          case 'Japan':
            url = `https://2d-japan.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
          case 'Europe':
            url = `https://drt-2d-europe.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
          case 'Middle East':
            url = `https://2d-me.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
          case 'Kuwait':
            url = `https://2d-me.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
          case 'Saudi Arabia':
            url = `https://2d-me.ushrauto-dev.com/${pointcloudID}/{z}/{x}/{-y}_0.png`
            break
        }
        let newLidarLayer = new TileLayer({
          name: pointcloudID + 'lidar',
          visible: true,
          opacity: 1.0,
          source: new XYZ({ url }),
          zIndex: group
        })
        this.map.addLayer(newLidarLayer)
      }
      this.$emit('newLidarDateCode', group)
    },
    availableLidarButtonCtrl(pointcloudID) {
      let returnClass = 'lidar-off'
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == pointcloudID + 'lidar') {
          layer.getVisible()
            ? (returnClass = 'btn-primary')
            : (returnClass = 'lidar-off')
        }
      })
      return returnClass
    },
    toggleLidarGroup(IDobj, handleVisibility, event) {
      let group = IDobj.dateCode.toString()
      let groupHasLayerCurrentlyVisible = false

      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name') ? layer.get('name').toString() : null
        if (layerNameStr && layerNameStr.includes(group) && layer.getVisible()) {
          groupHasLayerCurrentlyVisible = true
        }
      })

      if (groupHasLayerCurrentlyVisible) {
        if (handleVisibility) {
          this.map.getLayers().forEach(layer => {
            let layerNameStr = layer.get('name') ? layer.get('name').toString() : null
            if (layerNameStr && layerNameStr.includes(group)) {
              layer.setVisible(false)
            }
          })
        }
      } else {
        IDobj.pointcloudIDArr.forEach(pointcloudID => {
          this.toggleLidarLayer(pointcloudID, IDobj.dateCode, true)
        })
      }
      event.target.blur()
    },
    anyPointcloudOfLidarGroupVisible(dateCode) {
      let returnClass = 'lidar-group-off'
      let group = dateCode.toString()
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name') ? layer.get('name').toString() : null
        if (layerNameStr && layerNameStr.includes(group) && layer.getVisible()) {
          returnClass = 'btn-primary'
        }
      })
      return returnClass
    },
  },
  mounted() {
    this._setVh = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    }
    this._setVh()
    window.addEventListener('resize', this._setVh)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._setVh)
  }
}
</script>
